@if (inputService.show) {
  <ng-container [formGroup]="inputService.formGroup">
    <mat-form-field appearance="outline" style='max-width:150px;'>
      <mat-label>
        @if (inputService.formInputDefinition.titleIcon) {
          <mat-icon class='title-input-icon' [matTooltip]='inputService.formInputDefinition.titleTooltip'>{{inputService.formInputDefinition.titleIcon}}</mat-icon>
        }
        <span>{{inputService.computedTitle | translate}}</span>
      </mat-label>
      @if (inputService.inputConfig.hint) {
        <mat-hint>{{inputService.inputConfig.hint | translate}}</mat-hint>
      }
      @if (inputService.inputConfig.readOnly) {
        <input matInput readonly />
      }
      @if (inputService.control.value && inputService.inputConfig.readOnly) {
        <i [class]='inputService.control.value'></i>
      }
      @if (!inputService.inputConfig.readOnly) {
        <mat-select [placeholder]="inputService.inputConfig.placeholder | translate" [formControlName]='inputService.formControlKey'>
          @for (selectOption of selectOptions; track selectOption) {
            <mat-option [value]='selectOption.value'>
              <i [class]='selectOption.value' ></i>
            </mat-option>
          }
          <mat-select-trigger>
            <i [class]='inputService.control.value'></i>
          </mat-select-trigger>
        </mat-select>
      }
      @if (inputService.control.value && !inputService.inputConfig.readOnly) {
        <mat-icon matSuffix style='cursor: pointer;' (click)='inputService.control.setValue(null)'>close</mat-icon>
      }
      @if (!inputService.control.valid) {
        <mat-error>{{inputService.errorMessage | translate}}</mat-error>
      }
    </mat-form-field>
  </ng-container>
}